import { render, staticRenderFns } from "./MyClaimDashboardItemSba.vue?vue&type=template&id=271ef7c0&scoped=true&"
import script from "./MyClaimDashboardItemSba.vue?vue&type=script&lang=js&"
export * from "./MyClaimDashboardItemSba.vue?vue&type=script&lang=js&"
import style0 from "./MyClaimDashboardItemSba.vue?vue&type=style&index=0&id=271ef7c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271ef7c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
